// styles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../../assets/styles';

const pxToRem = (px: number): string => `${px / 16}rem`;

const useStyles = makeStyles((theme: Theme) => ({
  footer: {
    backgroundColor: Colors.White,
    borderTop: `1px solid ${Colors.Gray3}`,
    padding: `${pxToRem(28)} ${pxToRem(85)}`,
    textAlign: 'end',
    position: 'fixed',
    width: 'calc(100% - 74px)',
    bottom: 0,
  },
  button: {
    '&.MuiButton-root':{
      maxWidth: 180,
      marginLeft: 10,
    }
  },
  reportButton: {
    maxWidth: 247,
    marginLeft: 10,
  },
  secondaryButton: {
    textTransform: 'none',
  },
  calculationsNameInput: {
    width: 500,
  },
}));

export default useStyles;
